/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_Achievementunlocked1Inputs */

const id_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian terbuka`)
};

const ms_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian dibuka`)
};

const da_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement låst op`)
};

const de_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaft freigeschaltet`)
};

const en_us2_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement unlocked`)
};

const es_es2_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logro desbloqueado`)
};

const es_mx2_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logro desbloqueado`)
};

const fil_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-unlock ang achievement`)
};

const fr_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès débloqué`)
};

const it_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultato sbloccato`)
};

const hu_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmény feloldva`)
};

const nl_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestatie ontgrendeld`)
};

const no_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjon låst opp`)
};

const pl_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcie odblokowane`)
};

const pt_br2_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquista desbloqueada`)
};

const pt_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquista desbloqueada`)
};

const ro_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizare deblocată`)
};

const fi_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutus avattu`)
};

const sv_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestation upplåst`)
};

const vi_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã mở khóa thành tích`)
};

const tr_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarım açıldı`)
};

const cs_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěch odemčen`)
};

const bg_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постижение отключено`)
};

const ru_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижение открыто`)
};

const uk_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнення розблоковано`)
};

const ar_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم فتح الإنجاز`)
};

const hi_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धि अनलॉक`)
};

const th_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกความสำเร็จ`)
};

const ja_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績解除`)
};

const zh_cn2_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁成就`)
};

const zh_hant1_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖成就`)
};

const ko_profile_activity_achievementunlocked1 = /** @type {(inputs: Profile_Activity_Achievementunlocked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제 잠금 해제`)
};

/**
* | output |
* | --- |
* | "Achievement unlocked" |
*
* @param {Profile_Activity_Achievementunlocked1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_achievementunlocked1 = /** @type {((inputs?: Profile_Activity_Achievementunlocked1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_Achievementunlocked1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_achievementunlocked1(inputs)
	if (locale === "ms") return ms_profile_activity_achievementunlocked1(inputs)
	if (locale === "da") return da_profile_activity_achievementunlocked1(inputs)
	if (locale === "de") return de_profile_activity_achievementunlocked1(inputs)
	if (locale === "en-US") return en_us2_profile_activity_achievementunlocked1(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_achievementunlocked1(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_achievementunlocked1(inputs)
	if (locale === "fil") return fil_profile_activity_achievementunlocked1(inputs)
	if (locale === "fr") return fr_profile_activity_achievementunlocked1(inputs)
	if (locale === "it") return it_profile_activity_achievementunlocked1(inputs)
	if (locale === "hu") return hu_profile_activity_achievementunlocked1(inputs)
	if (locale === "nl") return nl_profile_activity_achievementunlocked1(inputs)
	if (locale === "no") return no_profile_activity_achievementunlocked1(inputs)
	if (locale === "pl") return pl_profile_activity_achievementunlocked1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_achievementunlocked1(inputs)
	if (locale === "pt") return pt_profile_activity_achievementunlocked1(inputs)
	if (locale === "ro") return ro_profile_activity_achievementunlocked1(inputs)
	if (locale === "fi") return fi_profile_activity_achievementunlocked1(inputs)
	if (locale === "sv") return sv_profile_activity_achievementunlocked1(inputs)
	if (locale === "vi") return vi_profile_activity_achievementunlocked1(inputs)
	if (locale === "tr") return tr_profile_activity_achievementunlocked1(inputs)
	if (locale === "cs") return cs_profile_activity_achievementunlocked1(inputs)
	if (locale === "bg") return bg_profile_activity_achievementunlocked1(inputs)
	if (locale === "ru") return ru_profile_activity_achievementunlocked1(inputs)
	if (locale === "uk") return uk_profile_activity_achievementunlocked1(inputs)
	if (locale === "ar") return ar_profile_activity_achievementunlocked1(inputs)
	if (locale === "hi") return hi_profile_activity_achievementunlocked1(inputs)
	if (locale === "th") return th_profile_activity_achievementunlocked1(inputs)
	if (locale === "ja") return ja_profile_activity_achievementunlocked1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_achievementunlocked1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_achievementunlocked1(inputs)
	return ko_profile_activity_achievementunlocked1(inputs)
});
export { profile_activity_achievementunlocked1 as "profile.activity.achievementUnlocked" }